import React from 'react';
import { Button } from '../button/button';
import './modal.scss';
export var Modal = function (_a) {
    var children = _a.children, title = _a.title, footer = _a.footer, show = _a.show, handleClose = _a.handleClose, extendClass = _a.extendClass, scrollable = _a.scrollable;
    var showHideClassName = show ? 'display-block' : 'display-none';
    var scrollClass = scrollable ? 'scrollable' : '';
    var close = function () {
        handleClose();
    };
    var mouseClick = function (event) {
        var _a;
        if (!((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.closest('modal-main'))) {
            document.removeEventListener('click', mouseClick);
            close();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "modal ".concat(showHideClassName), onClick: mouseClick }),
        React.createElement("section", { className: "".concat(showHideClassName, " modal-main ").concat(extendClass !== null && extendClass !== void 0 ? extendClass : '') },
            title && (React.createElement("header", { className: "modal-main__header" },
                title,
                React.createElement("div", { className: "modal-main__close-icon" },
                    React.createElement(Button, { variant: "bare", type: "button", onClick: close, icon: "close", iconPosition: "left" })))),
            React.createElement("div", { className: "modal-main-body ".concat(scrollClass) }, children),
            footer)));
};
